"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var amazon_config_store_type_script_ion_parser_1 = require("@amzn/amazon-config-store-type-script-ion-parser");
var amazon_config_store_model_tscommon_1 = require("@amzn/amazon-config-store-model-tscommon");
var FeatureRecord_1 = require("../feature/FeatureRecord");
var FeatureContext_1 = require("../feature/FeatureContext");
var InMemoryFeatureStorage_1 = __importDefault(require("../storage/InMemoryFeatureStorage"));
var ConfigParser = /** @class */ (function () {
    function ConfigParser() {
        this.ATTRIBUTE_NAME = 'attribute_name';
    }
    ConfigParser.prototype.parse = function (typeSafeClientProvider, configFiles) {
        var _this = this;
        var _a;
        var documentMap = this.getDocumentMap(configFiles.documents);
        var featureRecordMap = this.getFeatureRecordMap(configFiles.exactQueries, documentMap);
        var queries = __spreadArray(__spreadArray([], configFiles.exactQueries, true), ((_a = configFiles === null || configFiles === void 0 ? void 0 : configFiles.hierarchicalFallbackQueries) !== null && _a !== void 0 ? _a : []), true);
        var records = queries.reduce(function (recordsMap, query) {
            var contextualParameters = _this.getOrderedContextualParameters(typeSafeClientProvider.CONTEXTUAL_PARAMETERS, query.keys);
            query.sequenceIds.forEach(function (sequenceId) {
                var featureRecord = featureRecordMap.get(sequenceId);
                var featureContext = {
                    contextualParameters: contextualParameters,
                    attributeName: featureRecord.attributeName,
                };
                recordsMap.set((0, FeatureContext_1.stringifyFeatureContext)(featureContext), featureRecord);
            });
            return recordsMap;
        }, new Map());
        return new InMemoryFeatureStorage_1.default(records);
    };
    ConfigParser.prototype.getDocumentMap = function (documents) {
        return documents.reduce(function (map, document) { return map.set(document.sequenceId, document); }, new Map());
    };
    ConfigParser.prototype.getFeatureRecordMap = function (queries, documentMap) {
        var _this = this;
        return queries.reduce(function (featureRecordMap, query) {
            var featureRecord = _this.getFeatureRecord(_this.getSequenceId(query.sequenceIds), documentMap, query.keys[_this.ATTRIBUTE_NAME]);
            return featureRecordMap.set(_this.getSequenceId(query.sequenceIds), featureRecord);
        }, new Map());
    };
    ConfigParser.prototype.getSequenceId = function (sequenceIds) {
        if (sequenceIds.length !== 1) {
            throw new amazon_config_store_model_tscommon_1.ACSClientError('This query is not an exact query (more than one sequence id).');
        }
        return sequenceIds[0];
    };
    ConfigParser.prototype.getOrderedContextualParameters = function (contextualParameterOrder, keyMap) {
        return contextualParameterOrder.reduce(function (cpMap, cp) { return cpMap.set(cp, keyMap[cp]); }, new Map());
    };
    ConfigParser.prototype.getFeatureRecord = function (sequenceId, documentMap, attributeName) {
        var _a, _b;
        if (documentMap.get(sequenceId) === undefined) {
            throw new amazon_config_store_model_tscommon_1.ACSClientError("No record exist for sequence Id ".concat(sequenceId));
        }
        var document = documentMap.get(sequenceId);
        return {
            attributeName: attributeName,
            attributeValue: (0, FeatureRecord_1.ionValueToJsObject)((0, amazon_config_store_type_script_ion_parser_1.load)(document.attributeValue)),
            weblabRules: (_b = (_a = document.weblabRules) === null || _a === void 0 ? void 0 : _a.map(function (weblabRule) { return ({
                operands: weblabRule.operands,
                operator: weblabRule.operator,
                use: (0, FeatureRecord_1.ionValueToJsObject)((0, amazon_config_store_type_script_ion_parser_1.load)(weblabRule.use)),
            }); })) !== null && _b !== void 0 ? _b : [],
        };
    };
    return ConfigParser;
}());
exports.default = ConfigParser;
